import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button", "copyIcon", "checkIcon", "badge"]

  copy() {
    const text = this.sourceTarget.textContent || this.sourceTarget.value

    this.copyToClipboard(text).then((success) => {
      if (success) {
        this.showSuccess()
        this.dispatch("copied", { detail: { text } })
      }
    })
  }

  async copyToClipboard(text) {
    // Try modern Clipboard API first
    if (navigator.clipboard && navigator.clipboard.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return true
      } catch (err) {
        // Fall through to legacy method
      }
    }

    // Fallback for iOS WKWebView and older browsers
    return this.legacyCopy(text)
  }

  legacyCopy(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.left = "-9999px"
    textarea.style.top = "0"
    textarea.setAttribute("readonly", "")
    document.body.appendChild(textarea)

    // iOS-specific: need to select with setSelectionRange
    textarea.focus()
    textarea.setSelectionRange(0, text.length)

    let success = false
    try {
      success = document.execCommand("copy")
    } catch (err) {
      // Copy failed
    }

    document.body.removeChild(textarea)
    return success
  }

  showSuccess() {
    // Field variant: fly the "Copied" badge up from the center of the box.
    if (this.hasBadgeTarget) {
      const badge = this.badgeTarget
      badge.hidden = false
      badge.classList.remove("copy-email__badge--fly")
      // Force a reflow so a rapid re-copy restarts the flight from the start.
      void badge.offsetWidth
      badge.classList.add("copy-email__badge--fly")
      badge.addEventListener("animationend", () => { badge.hidden = true }, { once: true })
      return
    }

    if (this.hasCopyIconTarget && this.hasCheckIconTarget) {
      this.copyIconTarget.classList.add("hidden")
      this.checkIconTarget.classList.remove("hidden")

      setTimeout(() => {
        this.copyIconTarget.classList.remove("hidden")
        this.checkIconTarget.classList.add("hidden")
      }, 2000)
    }
  }
}
